import { onIdTokenChanged, User } from "firebase/auth";
import { useState, useEffect, createContext } from "react";
import { auth } from "../firebase";
import { AuthService } from "../services/AuthService";

export interface IAuthContext {
  user: User | null;
  setUser: (user: User) => void;
  initialAuthChecked: boolean;
}
export const AuthContext = createContext<IAuthContext>({
  user: null,
  setUser: () => {},
  initialAuthChecked: false,
});

export function AuthProvider({ children }: any) {
  const [user, setUser] = useState<User | null>(null);
  const [initialAuthChecked, setInitialAuthChecked] = useState(false);

  // listen for token changes
  // call setUser and write new token as a cookie
  useEffect(() => {
    return onIdTokenChanged(auth, async (user) => {
      console.log("onIdTokenChanged", user);

      if (!user) {
        setUser(null);
      } else {
        setUser(user);
      }

      setInitialAuthChecked(true);
    });
  }, []);

  // Force token refresh the token every 10 minutes.
  useEffect(() => {
    const handle = AuthService.startTokenAutoRefresh();
    return () => clearInterval(handle);
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, setUser, initialAuthChecked: initialAuthChecked }}
    >
      {children}
    </AuthContext.Provider>
  );
}
